import React from 'react';
// import PropTypes from 'prop-types';
import finalImage from '../images/thanks-img.webp';

/*
const propTypes = {
  sourceItems: PropTypes.arrayOf().isRequired,
};
*/

// const Thanks = ({ /* sourceItems */ }) => (
const Thanks = () => (
  <>
    <section className="section thx">
      <h2 className="h2 thx-title">
        Kiitos osallistumisesta! Olemme yhteydessä voittajiin arvonnan päätyttyä.
      </h2>
      
      <p className="customer-link-p">
         Tutustu AirVive -tuotteisiin tai osta omaksesi
        {' '}
        <a
          href="https://www.prisma.fi/haku?search=remington%20airvive"
        >
          täältä!
        </a>
      </p>
      
    </section>
    {/*
    <h2 className="h2 right-answers-title">
      Oikeat vastaukset:
    </h2>
    <ul className="list questions">
      {sourceItems.map((question) => {
        const { answers, rightAnswer } = question;
        const rightItems = [answers
          .find((answer) => answer.id === rightAnswer)];

        return (
          <>
            {rightItems.map((rightItem) => (
              <li className="question">
                <h3 className="right-answer-title">
                  {rightItem.title || 'Oikeaa vastausta ei löytynyt!'}
                </h3>
              </li>
            ))}
          </>
        );
      })}
    </ul>
    */}
  </>
);

// Thanks.propTypes = propTypes;

export default Thanks;
